import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes, faHeart, faShoppingCart, faBell, faSignOutAlt, faPlus } from "@fortawesome/free-solid-svg-icons";

const Sidebar = ({
  isOpen,
  onClose,
  isAuthenticated,
  user,
  categories,
  loadingCategories,
  wishlistCount,
  cartCount,
  unreadCount,
  location,
  onLoginClick,
  onLogout,
  navigate
}) => {
  const getLinkClass = (path) => {
    return location.pathname === path ? "bg-blue-50 text-blue-600" : "";
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 lg:hidden">
      {/* Overlay */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50"
        onClick={onClose}
      ></div>
      
      {/* Sidebar Content */}
      <div className="fixed inset-y-0 right-0 w-4/5 max-w-md bg-white shadow-xl z-50 transform transition-transform duration-300 ease-in-out overflow-y-auto">
        <div className="p-6">
          <div className="flex justify-end mb-6">
            <button 
              onClick={onClose}
              className="text-2xl text-gray-600 hover:text-gray-900"
            >
              <FontAwesomeIcon icon={faTimes} />
            </button>
          </div>

          <div className="mb-8 border-b pb-6">
            {isAuthenticated ? (
              <Link 
                to="/profile" 
                className="flex items-center space-x-3"
                onClick={onClose}
              >
                <div className="bg-gray-200 border-2 border-dashed rounded-xl w-16 h-16" />
                <div>
                  <p className="font-semibold text-lg">{user?.name || "User"}</p>
                  <p className="text-gray-600 text-sm">View Profile</p>
                </div>
              </Link>
            ) : (
              <button
                className="flex items-center space-x-3 w-full"
                onClick={onLoginClick}
              >
                <div className="bg-gray-200 border-2 border-dashed rounded-xl w-16 h-16" />
                <div>
                  <p className="font-semibold text-lg">Login / Signup</p>
                  <p className="text-gray-600 text-sm">Access account features</p>
                </div>
              </button>
            )}
          </div>

          <div className="mb-8">
            <h3 className="text-gray-500 text-sm font-medium uppercase mb-3">Categories</h3>
            {loadingCategories ? (
              <div className="space-y-2">
                {[...Array(5)].map((_, i) => (
                  <div key={i} className="h-10 w-full bg-gray-200 rounded animate-pulse"></div>
                ))}
              </div>
            ) : (
              <div className="space-y-2">
                {categories.map((category) => (
                  <Link
                    key={category.id}
                    to={category.path}
                    className={`flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-100 ${getLinkClass(category.path)}`}
                    onClick={onClose}
                  >
                    <span>{category.name}</span>
                  </Link>
                ))}
              </div>
            )}
          </div>

          <div className="mb-8">
            <h3 className="text-gray-500 text-sm font-medium uppercase mb-3">Your Account</h3>
            <div className="space-y-2">    
              {isAuthenticated && (
                <>
                  <Link
                    to="/wishlist"
                    className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-100"
                    onClick={onClose}
                  >
                    <FontAwesomeIcon icon={faHeart} />
                    <span>Wishlist</span>
                    {wishlistCount > 0 && (
                      <span className="ml-auto bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                        {wishlistCount}
                      </span>
                    )}
                  </Link>
                  <Link
                    to="/cart"
                    className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-100"
                    onClick={onClose}
                  >
                    <FontAwesomeIcon icon={faShoppingCart} />
                    <span>Cart</span>
                    {cartCount > 0 && (
                      <span className="ml-auto bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                        {cartCount}
                      </span>
                    )}
                  </Link>
                  <Link
                    to="/notifications"
                    className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-100"
                    onClick={onClose}
                  >
                    <FontAwesomeIcon icon={faBell} />
                    <span>Notifications</span>
                    {unreadCount > 0 && (
                      <span className="ml-auto bg-red-600 text-white text-xs font-semibold px-2 py-1 rounded-full">
                        {unreadCount}
                      </span>
                    )}
                  </Link>
                  <button
                    className="flex items-center space-x-3 p-3 rounded-lg hover:bg-gray-100 w-full text-left text-red-600"
                    onClick={onLogout}
                  >
                    <FontAwesomeIcon icon={faSignOutAlt} />
                    <span>Logout</span>
                  </button>
                </>
              )}
            </div>
          </div>

          {isAuthenticated && (
            <Link
              to="/become-seller"
              className="flex items-center space-x-3 p-3 bg-blue-50 text-blue-600 rounded-lg font-medium"
              onClick={onClose}
            >
              <FontAwesomeIcon icon={faPlus} />
              <span>Become a Seller</span>
            </Link>
          )}
        </div>
      </div>
    </div>
  );
};

export default Sidebar;